import DEFAULTVALUE from '@/app/constants/defaultValue';
import { ByCodeResponse } from '@/app/models/projects';
import { useUpdateProjectsMutation } from '@/app/services/projectsApi';
import DrawerButtons from '@/components/common/DrawerButtons';
import ModalPageTitle from '@/components/common/ModalPageTitle';
import { Box, useTheme } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ReportItem from '../ReportItem';

interface NewEditInitialBalanceProps {
  selectItem: ByCodeResponse;
  setDrawerOpen: (open: boolean) => void;
}

export default function NewEditInitialBalance(props: NewEditInitialBalanceProps) {
  const { t } = useTranslation(['costTracking', 'common']);
  const theme = useTheme();
  const { selectItem, setDrawerOpen } = props;
  const [justification, setJustification] = useState<string>(selectItem?.justify != null ? selectItem?.justify : '');

  const handleJustifyChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setJustification(event.target.value);
  };

  const handleCancel = () => {
    setDrawerOpen(false);
  };

  const [update] = useUpdateProjectsMutation();

  const handleSubmit = async () => {
    setDrawerOpen(false);
    await toast.promise(
      update({
        id: selectItem?.id as number,
        initialBalance: selectItem.initialBalance || DEFAULTVALUE,
        justify: justification,
      }).unwrap(),
      {
        pending: t('common:processing.wait.a.moment') as string,
        success: t('common:comments.saved.successfully') as string,
        error: t('common:processing.failed') as string,
      },
      {
        position: toast.POSITION.TOP_RIGHT,
      },
    );
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 24px)',
        maxHeight: 'calc(100vh - 24px)',
        flexGrow: 'inherit',
      }}
    >
      <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
        <ModalPageTitle title={t('comment.rubric.values')} />
        <Box sx={{ width: '100%', height: theme.spacing(0.25), bgcolor: 'grey.300', mb: 1 }} />

        <ReportItem
          name={t('common:value')}
          value={selectItem.initialBalance}
          justify={justification as string}
          onJustifyChange={handleJustifyChange}
        />
      </Box>

      <Box sx={{ mt: 'auto' }}>
        <DrawerButtons onSave={handleSubmit} onCancel={handleCancel} />
      </Box>
    </Box>
  );
}
